import React from 'react'
import styled from 'styled-components'
import { isEmpty } from 'ramda'
import { Field, useFormikContext } from 'formik'

import { breakpoints, colors, fontSizes, fontWeights } from '@/styles'
import Error from '@/components/form/error'

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  width: 100%;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 0 16px;
  }
`

const RadioButton = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  border-radius: 4px;
  border: 1px solid ${colors.grey88};
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.medium};
  position: relative;

  &:hover {
    background: ${colors.blue96};
  }
`

const Label = styled.label`
  width: 100%;
  padding: 16px 16px 16px 44px;
  cursor: pointer;
`

const Input = styled.input`
  padding: 16px;
  position: absolute;
  left: 16px;
  cursor: pointer;

  &:checked {
    filter: contrast(2000%) grayscale(1);
  }
`

const CustomRadioButton = (props: any) => {
  const { name, options, ...rest } = props
  const context = useFormikContext()
  const errors: { [name: string]: string } = context?.errors

  return (
    <RadioWrapper>
      <Field name={name} {...rest}>
        {({ field }: any) => {
          return options.map((option: any) => (
            <RadioButton key={option.key} id={option.clickId}>
              <Input
                type="radio"
                id={option.value}
                {...field}
                value={option.value}
                checked={field.value === option.value}
                aria-describedby={`${name}-message`}
                aria-invalid={!isEmpty(errors)}
              />
              <Label htmlFor={option.value}>{option.key}</Label>
            </RadioButton>
          ))
        }}
      </Field>

      <Error name={name} />
    </RadioWrapper>
  )
}

export default CustomRadioButton
